// This file is AUTOGENERATED, do not edit it manually!!!

export const activityList = {
    Activities: '1#Activiteit#Activiteiten',
    Activities_Text: '1#{0} Activiteit#{0} Activiteiten',
    activities_without_dates: 'Activiteiten zonder data',
    Activity: 'Activiteit',
    Activity_Billing: 'Facturabel',
    Activity_Cost: 'Activiteitskosten',
    Activity_CostVariance: 'Kostenafwijking',
    Activity_HoursLeft: 'over',
    Activity_InternalCost: 'Werkelijke kosten',
    Activity_Profit: 'Winst',
    Add_Task: 'Taak toevoegen',
    AITaskGeneration_projectName: 'Naam',
    AITaskGeneration_retry: 'Opnieuw proberen',
    AITaskGeneration_title: 'Maak projectplan met AI',
    All_Saved_Views: 'Alle opgeslagen weergaven',
    Apply_Text: 'Toepassen',
    apply_wbs_sorting: 'WBS-sortering toepassen',
    Archive_Success_Message: 'Het project \"{0}\" is gearchiveerd',
    archived_label: '(gearchiveerd)',
    Baseline_Text: 'Basislijn',
    Board_CreateTaskInProjectPlaceholder: 'Aanmaken in project',
    Board_ShowMore: 'Meer weergeven',
    Browse_Views: 'Bladeren door weergaven',
    Budget_problem_project: 'Werkelijke kosten overschrijden totaal budget',
    Budget_problem_task: 'Werkelijke arbeidskosten overschrijden totaal budget',
    Budget_Text: 'Budget',
    Budget_warning_project: 'EAC-kosten overschrijden totaal budget',
    Budget_warning_task: 'EAC-arbeidskosten overschrijden totaal budget',
    By_Text: 'door',
    change_activity_type_to_label: 'Activiteitstype wijzigen in',
    ChooseTemplateDropdownLabel: 'Maak een project op basis van een bestaande sjabloon',
    Counter: 'Teller projecten/activiteiten',
    CPI_Problem: 'CPI ligt onder de drempel',
    Create: 'Aanmaken',
    create_snapshot: 'Projectmomentopnames',
    CreateNewItem: 'Typ hier om een nieuw project of activiteit aan te maken...',
    CreateProject_Tooltip: 'Een nieuw project aanmaken',
    CriticalPath_Text: 'Kritieke pad',
    CustomField_No: 'Nee',
    CustomField_Yes: 'Ja',
    DayPluralFormat: '1#Dag#Dagen',
    Default_Text: 'Standaard',
    Delete_Confirmation_Title: 'Deze objecten verwijderen?',
    Delete_Entity_Confirmation_Archive_Description: '<b>In plaats daarvan kunt u ook de projectgegevens archiveren en deze indien nodig herstellen.</b>',
    Delete_Text: 'Verwijderen',
    DeleteEntityConfirmation: 'inclusief alle timelogs, berichten en bijgevoegde bestanden {0}. Deze actie kan niet ongedaan worden gemaakt!',
    DeletePermanently: 'Definitief verwijderen',
    DeleteVerb: '1#wordt permanent verwijderd#worden permanent verwijderd',
    DeleteVerbActivity: '1#wordt permanent verwijderd#worden permanent verwijderd',
    Dependency_AddMore_Text: 'Meer afhankelijkheden toevoegen',
    Dependency_Cancel: 'Annuleren',
    Dependency_Choose: 'Selecteer activiteit of typ een trefwoord...',
    Dependency_days: 'dagen',
    Dependency_DelayWarningExample: 'Voorbeeld: -34, 42',
    Dependency_DelayWarningText: 'Voer getallen in van -1000 tot 1000',
    Dependency_DependencyCycle: 'Sorry, de afhankelijkheid kan niet worden gemaakt omdat de geselecteerde activiteit een afhankelijkheidslus creëert.',
    Dependency_DependencyType_Text: 'Afhankelijkheidstype',
    Dependency_DependsOn_Text: 'Is afhankelijk van',
    Dependency_FinishToStart_Minus1: 'Activiteit begint de dag voor {0} eindigt',
    Dependency_FinishToStart_Minus1_Pattern: 'Activiteit begint <b>de dag ervoor</b> \"{0}\" eindigt',
    Dependency_FinishToStart_Minus2: 'Activiteit begint {1} voor {0} eindigt',
    Dependency_FinishToStart_Minus2_Pattern: 'Activiteit begint <b>{1} voor</b> \"{0}\" eindigt',
    Dependency_FinishToStart_Plus0: 'Activiteit begint de dag {0} eindigt',
    Dependency_FinishToStart_Plus0_Pattern: 'Activiteit begint <b>op de dag</b> \"{0}\" eindigt',
    Dependency_FinishToStart_Plus1: 'Activiteit begint de dag na {0} eindigt',
    Dependency_FinishToStart_Plus1_Pattern: 'Activiteit begint <b>de dag erna</b> \"{0}\" eindigt',
    Dependency_FinishToStart_Plus2: 'Activiteit begint {1} na {0} eindigt',
    Dependency_FinishToStart_Plus2_Pattern: 'Activiteit begint <b>{1} na</b> \"{0}\" eindigt',
    Dependency_FinishWhenStarted_Text: 'Activiteit voltooid wanneer \"{0}\" begint',
    Dependency_FinishWhenStarted_Title: 'Start naar voltooiing',
    Dependency_Lag_Text: 'Vertraging',
    Dependency_ParentChildRelationship: 'Sorry, de afhankelijkheid kan niet worden gemaakt omdat een van de activiteiten een ouder is en de andere zijn kind (subactiviteit).',
    Dependency_Reason: 'Reden',
    Dependency_Remove_Text: 'Verwijderen',
    Dependency_RemoveSingleDependency_Text: 'Afhankelijkheid verwijderen',
    Dependency_Save: 'Opslaan',
    Dependency_SelectDependsOn_Text: 'Selecteer Is afhankelijk van',
    Dependency_StartsWhenFinished_Text: 'Activiteit begint wanneer \"{0}\" is voltooid',
    Dependency_StartsWhenFinished_Title: 'Voltooiing naar start',
    Dependency_StartsWhenStarted_Text: 'Activiteit begint wanneer \"{0}\" begint',
    Dependency_StartsWhenStarted_Title: 'Start naar start',
    Dependency_StartToFinish_Minus1: 'Activiteit eindigt de dag voor {0} begint',
    Dependency_StartToFinish_Minus1_Pattern: 'Activiteit eindigt <b>de dag ervoor</b> \"{0}\" begint',
    Dependency_StartToFinish_Minus2: 'Activiteit eindigt {1} voor {0} begint',
    Dependency_StartToFinish_Minus2_Pattern: 'Activiteit eindigt <b>{1} voor</b> \"{0}\" begint',
    Dependency_StartToFinish_Plus0: 'Activiteit eindigt de dag {0} begint',
    Dependency_StartToFinish_Plus0_Pattern: 'Activiteit eindigt <b>op de dag</b> \"{0}\" begint',
    Dependency_StartToFinish_Plus1: 'Activiteit eindigt de dag na {0} begint',
    Dependency_StartToFinish_Plus1_Pattern: 'Activiteit eindigt <b>de dag erna</b> \"{0}\" begint',
    Dependency_StartToFinish_Plus2: 'Activiteit eindigt {1} na {0} begint',
    Dependency_StartToFinish_Plus2_Pattern: 'Activiteit eindigt <b>{1} na</b> \"{0}\" begint',
    Dependency_StartToStart_Minus1: 'Activiteit begint de dag voor {0} begint',
    Dependency_StartToStart_Minus1_Pattern: 'Activiteit start <b>één dag voor</b> \"{0}\" begint',
    Dependency_StartToStart_Minus2: 'Activiteit start {1} dagen voor {0} begint',
    Dependency_StartToStart_Minus2_Pattern: 'Activiteit start <b>{1} dagen voor</b> \"{0}\" begint',
    Dependency_StartToStart_Plus0: 'Activiteit start op dezelfde dag als {0} begint',
    Dependency_StartToStart_Plus0_Pattern: 'Activiteit start <b>op dezelfde dag als</b> \"{0}\" begint',
    Dependency_StartToStart_Plus1: 'Activiteit start één dag na {0} begint',
    Dependency_StartToStart_Plus1_Pattern: 'Activiteit start <b>één dag na</b> \"{0}\" begint',
    Dependency_StartToStart_Plus2: 'Activiteit start {1} dagen na {0} begint',
    Dependency_StartToStart_Plus2_Pattern: 'Activiteit start <b>{1} dagen na</b> \"{0}\" begint',
    Dependency_Warning_Text: 'De bewerking kon niet worden voltooid.',
    Details: 'Details',
    Edit_Text: 'Bewerken',
    empty_sorting_list: 'Geen sorteeropties gevonden',
    EnterProjectName: 'Voer de naam van het project in',
    EnterTaskName: 'Voer de naam van de taak in',
    EnterViewName_Text: 'Voer de naam van de weergave in',
    Error_DragAndDrop_BreakingHierarchy: 'Een activiteit kan geen onderdeel zijn van zijn eigen sub-activiteit.',
    Error_DragAndDrop_ChangeParentInFlattenView: 'Wijzig de platte weergave in hiërarchisch om activiteitshierarchie te wijzigen.',
    Error_DragAndDrop_CycleDependencies: 'Deze bewerking zal een cyclische afhankelijkheid creëren (bijvoorbeeld Taak A is afhankelijk van Taak B, Taak B is afhankelijk van Taak A).',
    Error_DragAndDrop_DifferentProjects: 'U kunt geen activiteit naar een ander project verplaatsen (gebruik de details van de activiteit).',
    Error_DragAndDrop_ReorderWithSorting: 'Voor het opnieuw ordenen van activiteiten moet een WBS oplopende sortering worden toegepast.',
    Error_PresetNotFound: 'De geselecteerde weergave is verwijderd of niet gedeeld. Vernieuw de pagina om door te gaan.',
    EstimatedHours_problem: 'De daadwerkelijke uren overschrijden de geschatte uren',
    export_activities: 'Activiteiten',
    export_activities_expanded_only: 'Activiteiten (alleen uitgevouwen)',
    Export_Activities_Text: 'Exporteer activiteiten naar CSV',
    Export_Import_Text: 'Exporteren en importeren',
    export_projects: 'Projecten',
    Export_Projects_Text: 'Exporteer projecten naar CSV',
    flat_view: 'Platte weergave',
    From: 'vanaf',
    Group_By_Portfolio: 'Groeperen op portfolio',
    group_by_project: 'Groeperen op project',
    Hide_Counter: 'Verberg telling van projecten/activiteiten',
    Hide_Text: 'Verbergen',
    hide_uncategorized_tasks: 'Verberg activiteiten die niet overeenkomen met een kalender',
    Hours_Short_Text: 'u',
    Import_CSV_Text: 'Importeren vanuit CSV',
    Import_MSProject_Text: 'Importeren vanuit MS Project',
    Import_Text: 'Importeren',
    Indicator_Counter_Snooze_Tooltip: '1#{0} item heeft problemen#{0} items hebben problemen',
    Indicator_Counter_Tooltip: 'Aantal activiteiten in gevaar',
    Indicator_Project_Tooltip: 'Het project heeft aandacht nodig op:',
    Indicator_Snooze_1_Week: 'Voor 1 week',
    Indicator_Snooze_4_Hours: 'Voor 4 uur',
    Indicator_Snooze_Cancel: 'Snooze annuleren',
    Indicator_Snooze_Custom: 'Aangepast',
    Indicator_Snooze_Custom_Modal_Header: 'Melding snoozen',
    Indicator_Snooze_Forever: 'Voor altijd',
    Indicator_Snooze_Menu_Text: 'Probleemindicatie snoozen',
    Indicator_Snooze_Message: 'Probleemindicatie voor u gesnoozed tot {0}.',
    Indicator_Snooze_Message_Forever: 'Probleemindicatie voor u gesnoozed voor altijd.',
    Indicator_Snooze_Until_Tomorrow: 'Tot morgen',
    Indicator_Task_Tooltip: 'De activiteit heeft aandacht nodig op:',
    Learn_More_Text: 'Meer informatie',
    Loading_Text: 'Bezig met laden...',
    More_Tasks: '{0} meer',
    MoreActions_AddAIActivities: 'Projectplan maken met AI',
    MoreActions_AddNextActivity: 'Volgende activiteit toevoegen',
    MoreActions_AddSubActivity: 'Sub-activiteit toevoegen',
    MoreActions_SaveProjectAsTemplate: 'Opslaan als sjabloon',
    MoreActions_SetAsMilestone: 'Instellen als mijlpaal',
    MoreActions_UnsetAsMilestone: 'Mijlpaal instellingen opheffen',
    My_Presets: 'Mijn weergaven',
    My_Text: 'Mijn',
    MyPresetName_Text: 'Van mij',
    NewProject: 'Nieuw project',
    NewProjectBasedOn: 'Nieuw project op basis van {0}',
    NewTask: 'Nieuwe taak',
    no_custom_field_value_label: 'n.v.t.',
    No_Portfolio: 'Zonder portfolio',
    no_project_custom_fields_created_text: 'Er zijn geen projectaangepaste velden aangemaakt',
    No_Templates_Text: 'Geen sjablonen gevonden.',
    NoSavedViews_Text: 'Geen opgeslagen weergaven.',
    Of: 'van de',
    old_sort_az: 'A→Z',
    old_sort_za: 'Z→A',
    parent_activities: 'Ouderactiviteiten',
    Portfolios_Text: '1#{0} Portfolio#{0} Portfolios',
    preset_delete: 'Weergave verwijderen',
    preset_delete_confirmation: 'Weergave {0} verwijderen?',
    preset_rename: 'Weergavenaam wijzigen',
    preset_save: 'Weergave opslaan',
    preset_saveAs: 'Weergave opslaan als',
    preset_share: 'Delen met iedereen in deze ruimte',
    preset_unshare_confirmation: 'Weergave {0} niet meer delen?',
    Project: 'Project',
    Project_ActualBudgetProfitability: 'Werkelijke budgetwinstgevendheid',
    Project_BudgetedCost: 'Totaal projectbudget',
    Project_CostVariance: 'Kostenafwijking',
    Project_EstimatedBudgetProfitability: 'Geschatte budgetwinstgevendheid',
    Project_Expenses: 'Uitgaven',
    project_info: 'Projectinformatie',
    Project_InternalCost: 'Werkelijke kosten',
    Project_ProjectBilling: 'Project facturering',
    Project_ProjectProfit: 'Projectwinst',
    Project_ProjectProfitability: 'Winstgevendheid',
    ProjectArchive: 'Project (gearchiveerd)',
    ProjectEndDate_problem: 'Het project is niet op de vervaldatum voltooid',
    Projects: '1#Project#Projecten',
    Projects_Text: '1#{0} Project#{0} Projecten',
    Rename_Text: 'Naam wijzigen',
    Restore_Text: 'Herstellen',
    Save_Text: 'Opslaan',
    SaveAs_Text: 'Opslaan als',
    Share_Text: 'Delen',
    Shared_With_Me: 'Met mij gedeeld',
    show_archived_projects: 'Toon gearchiveerde projecten',
    Show_Text: 'Tonen',
    SortBy_Text: 'Sorteren op',
    SPI_Problem: 'SPI is lager dan de drempel',
    SubActivities: '1#Subactiviteit#Subactiviteiten',
    switchToClassicUI: 'Overschakelen naar oude UI',
    switchToNewUI: 'Overschakelen naar nieuwe UI',
    tab_Board: 'Bord',
    tab_Calendar: 'Kalender',
    tab_Gantt: 'Gantt',
    tab_Table: 'Tabel',
    TargetProfit_warning: 'Richtwinst lager dan verwachte winst',
    TargetProfitPercentage_warning: 'Richtwinst (%) lager dan verwachte winst (%)',
    TaskEndDate_problem: 'De taak is niet op tijd voltooid',
    TaskEndDate_warning: 'De taak eindigt later dan de bovenliggende taak',
    TaskStartDate_warning: 'De taak start eerder dan de bovenliggende taak',
    Templates_Popup_Title: 'Gebaseerd op sjabloon:',
    TimerText: '1#{0} seconde#{0} seconden',
    Tools_Menu_Text: 'Gereedschap',
    Tooltip_DefaultPresetIcon: 'Selecteer of beheer opgeslagen weergaven',
    Tooltip_RevertToDefaultPreset: 'Terugkeren naar de standaardweergave',
    Tooltip_SaveDefaultPreset: 'Sla uw huidige lay-out en filters op als een Weergave',
    Tooltip_SharedByMePreset: 'Gedeeld door mij',
    TotalTargetRevenue_warning: 'EAC Billable minder dan Totale Target Omzet',
    Unarchive_Success_Message: 'Project \"{0}\" is gedearchiveerd.',
    uncategorized_tasks: 'Activiteiten zonder kalenders',
    Unshare_Text: 'Niet delen',
    View_Project_Link: 'Bekijk project',
    WBSNumber_Text: 'WBS',
    what_to_export: 'Wat te exporteren?',
};
